import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { UserAuthenticationService } from './services/user-authentication.service';
import { environment } from '../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const userAuthenticationService = inject(UserAuthenticationService);
  const authToken = userAuthenticationService.getStoredJwtToken();

  const apiUrls = Object.values(environment.proxyUrls);
  const isApiCall = apiUrls.some((url) => req.url.startsWith(url));

  if (!isApiCall) {
    return next(req);
  }

  const excludedUrls = ['/login', '/register'];
  const isExcluded = excludedUrls.some((url) => req.url.includes(url));
  const reportApiCall = req.url.includes(environment.proxyUrls.reportApi);

  if (isExcluded || reportApiCall) {
    return next(req);
  }

  const authReq = req.clone({
    setHeaders: {
      Authorization: authToken ? `Bearer ${authToken}` : '',
    },
  });

  return next(authReq);
};
